module.exports = __webpack_public_path__ + "static/media/github_logo.e64de169.png";